import { Modal } from 'bootstrap';

import { cartItemEndpoint } from '../main/endpoints';
import { sendJSON } from '../main/utils';
import GtmRemoveFromCart from './google-tag-manager/remove-from-cart';

// inputs
const agreedToYearlyBillingCheckbox = document.getElementById(
  'agreed-to-yearly-billing',
) as HTMLInputElement | null;
const billingOptionInputs = document.querySelectorAll(
  '.form-check-input[name="auto_recharge"]',
);
// buttons
const canCheckoutButton = document.getElementById('shopping-cart-checkout');
const cannotCheckoutButton = document.getElementById(
  'shopping-cart-checkout-disabled',
);
const removeProductButtons =
  document.querySelectorAll<HTMLButtonElement>('.js-cart-remove');
const termSelects = document.querySelectorAll<HTMLSelectElement>(
  '.js-cart-term-select',
);
// other elements
const billingOptionsDiv = document.getElementsByClassName(
  'js-billing-options',
)[0] as HTMLElement | null;
const cartDiv = document.getElementsByClassName('cart')[0] as
  HTMLElement | undefined;
let serviceBillingOption = 'Auto-Recharge';
const cartErrorMsg = document.querySelector('.cart-form-error');

// functions
cannotCheckoutButton?.addEventListener('click', (e) => {
  e.preventDefault();
  const agreed = agreedToYearlyBillingCheckbox?.checked ?? false;

  canCheckoutButton?.classList.toggle('d-none', !agreed);
  cannotCheckoutButton.classList.toggle('d-none', agreed);
  cartErrorMsg?.classList.toggle('d-none', agreed);
});

const setCheckoutButtonsState = () => {
  if (!canCheckoutButton || !cannotCheckoutButton) return;

  const agreed = agreedToYearlyBillingCheckbox?.checked ?? false;
  const canCheckout =
    checkout.person_can_purchase &&
    !checkout.has_duplicate_subscription &&
    (!checkout.contains_yearly_subscription || agreed);

  canCheckoutButton.classList.toggle('d-none', !canCheckout);
  cannotCheckoutButton.classList.toggle('d-none', canCheckout);
};

agreedToYearlyBillingCheckbox?.addEventListener('change', () => {
  setCheckoutButtonsState();
  cartErrorMsg?.classList.toggle(
    'd-none',
    agreedToYearlyBillingCheckbox.checked,
  );
});

window.addEventListener('load', () => {
  // Set initial state of checkout buttons
  setCheckoutButtonsState();
});

const removeProductFromCart = async (event: Event) => {
  // currentTarget, not target: the click lands on the label inside the button.
  const target = event.currentTarget as HTMLButtonElement;
  const productId = target.dataset.productId;
  if (!productId) return;
  const rowElement = target.closest('tr');
  if (rowElement) rowElement.classList.add('opacity--04');
  try {
    const response = await sendJSON(
      `${cartItemEndpoint}${productId}`,
      'DELETE',
      {},
    );
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    GtmRemoveFromCart(target, serviceBillingOption);

    // Preserve state of yearly sub checkbox and reload page
    const params = new URLSearchParams(window.location.search);
    const billingConsent = agreedToYearlyBillingCheckbox?.checked ? '1' : '0';
    params.set('billing_consent', billingConsent);
    window.location.search = params.toString();
  } catch (ignoredError) {
    const errorModal = document.getElementById('cart-error-remove');
    if (errorModal) new Modal(errorModal).show();
  } finally {
    if (rowElement) rowElement.classList.remove('opacity--04');
  }
};
const updatePaymentMethod = async (event: Event) => {
  const target = event.target as HTMLInputElement;
  const errorModal = document.querySelector('#cart-error-update');
  if (!services || !services.length) {
    // There are no services in the cart so we can't update the payment method
    if (errorModal) new Modal(errorModal).show();
    return;
  }
  const rowElement = target.closest('tr');
  if (rowElement) rowElement.classList.add('opacity--04');

  const service = services[0];
  const payload = {
    stripe_price_id: service.stripe_price_id,
    stripe_quantity: service.price, // For Service-Credit, quantity equals the dollar amount
    service_credit_widget: service.service_credit_widget,
    auto_recharge: target.dataset?.recharge === 'true',
  };
  serviceBillingOption = payload.auto_recharge
    ? 'Auto-Recharge'
    : 'Pay As You Go';

  try {
    const response = await sendJSON(
      `${cartItemEndpoint}${service.id}`,
      'PUT',
      payload,
    );
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data = await response.json();
    if (Array.isArray(data.services)) services = data.services;
  } catch (ignoredError) {
    if (errorModal) new Modal(errorModal).show();
  } finally {
    if (rowElement) rowElement.classList.remove('opacity--04');
  }
};

// Data
let services: { [key: string]: string | boolean | number }[] = [];
if (billingOptionsDiv) {
  try {
    if (!billingOptionsDiv.dataset.services) throw new Error('No services');
    services = JSON.parse(billingOptionsDiv.dataset.services);
  } catch (ignoredError) {
    services = [];
  }
}
let checkout: { [key: string]: boolean } = {};
if (cartDiv) {
  try {
    if (!cartDiv.dataset.checkout) throw new Error('No checkout');
    checkout = JSON.parse(cartDiv.dataset.checkout);
  } catch (ignoredError) {
    checkout = {};
  }
}

// Attach event listeners
removeProductButtons.forEach((el) => {
  el.addEventListener('click', removeProductFromCart);
  el.removeAttribute('disabled');
});

billingOptionInputs.forEach((el) => {
  el.addEventListener('change', updatePaymentMethod);
  el.removeAttribute('disabled');
});

termSelects.forEach((el) => {
  el.addEventListener('change', () => {
    const consent =
      el.form?.querySelector<HTMLInputElement>('.js-cart-consent');
    if (consent) {
      consent.value = agreedToYearlyBillingCheckbox?.checked ? '1' : '0';
    }
    el.form?.submit();
  });
  el.removeAttribute('disabled');
});
